"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectNodeDependencies = void 0;

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var ObjectNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createObjectNode: _factoriesAny.createObjectNode
};
exports.ObjectNodeDependencies = ObjectNodeDependencies;